/**
 * 采购单状态枚举（与 server/constants/purchaseOrderStatus.js 保持一致）
 * 已去除「待确认采购信息」；默认入口为待下单。
 * 已废弃「待补货」(8)：补货链路已移除，常量仅兼容历史数据展示。
 */

export const PURCHASE_STATUS = {
  PENDING_ORDER: 1,
  PENDING_PAY: 2,
  PENDING_RECEIVE: 3,
  INBOUND_DEFECT: 7,
  /** @deprecated 补货链路已移除 */
  PENDING_REPLENISH: 8,
  PENDING_REFUND: 4,
  PENDING_RETURN: 5,
  COMPLETED: 6,
  VOID: -1,
};

/** 允许新增收货单的采购主状态 */
export const RECEIPT_ALLOWED_STATUSES = [
  PURCHASE_STATUS.PENDING_ORDER,
  PURCHASE_STATUS.PENDING_PAY,
  PURCHASE_STATUS.PENDING_RECEIVE,
];

/** 支付前冻结结案状态 */
export const PRE_SETTLE_STATUSES = [PURCHASE_STATUS.PENDING_ORDER, PURCHASE_STATUS.PENDING_PAY];

export function isPreSettleStatus(status) {
  return PRE_SETTLE_STATUSES.includes(Number(status));
}

export function isReceiptAllowedStatus(status) {
  return RECEIPT_ALLOWED_STATUSES.includes(Number(status));
}

export const PURCHASE_STATUS_LABEL = {
  [PURCHASE_STATUS.PENDING_ORDER]: "待下单",
  [PURCHASE_STATUS.PENDING_PAY]: "待支付",
  [PURCHASE_STATUS.PENDING_RECEIVE]: "待收货",
  [PURCHASE_STATUS.INBOUND_DEFECT]: "入库缺陷",
  /** @deprecated */
  [PURCHASE_STATUS.PENDING_REPLENISH]: "待补货",
  [PURCHASE_STATUS.PENDING_REFUND]: "待退款",
  [PURCHASE_STATUS.PENDING_RETURN]: "待退货",
  [PURCHASE_STATUS.COMPLETED]: "已完成",
  [PURCHASE_STATUS.VOID]: "已作废",
};

export const REFUND_STATUS = {
  NONE: 0,
  NO_NEED: 1, // 历史兼容
  PENDING: 2,
  DONE: 3,
};

export const REFUND_STATUS_LABEL = {
  [REFUND_STATUS.NONE]: "",
  [REFUND_STATUS.NO_NEED]: "无需退款",
  [REFUND_STATUS.PENDING]: "待退款",
  [REFUND_STATUS.DONE]: "已退款",
};

export const RETURN_STATUS = {
  NONE: 0,
  NO_NEED: 1, // 历史兼容
  PENDING: 2,
  DONE: 3,
};

export const RETURN_STATUS_LABEL = {
  [RETURN_STATUS.NONE]: "",
  [RETURN_STATUS.NO_NEED]: "无需退货",
  [RETURN_STATUS.PENDING]: "待退货",
  [RETURN_STATUS.DONE]: "已退货",
};

/** 质检处置（与 server QUALITY_DISPOSITION 一致） */
export const QUALITY_DISPOSITION = {
  NONE: 0,
  SKIP_BOTH: 1,
  SKIP_RETURN_ONLY: 2,
  RETURN_AND_REFUND: 3,
  EXCHANGE: 4,
};

export const STATUS_TABS = [
  { name: String(PURCHASE_STATUS.PENDING_ORDER), code: PURCHASE_STATUS.PENDING_ORDER, label: "待下单", showBadge: true },
  { name: String(PURCHASE_STATUS.PENDING_PAY), code: PURCHASE_STATUS.PENDING_PAY, label: "待支付", showBadge: true },
  { name: String(PURCHASE_STATUS.PENDING_RECEIVE), code: PURCHASE_STATUS.PENDING_RECEIVE, label: "待收货", showBadge: true },
  { name: String(PURCHASE_STATUS.INBOUND_DEFECT), code: PURCHASE_STATUS.INBOUND_DEFECT, label: "入库缺陷", showBadge: true },
  { name: String(PURCHASE_STATUS.PENDING_REFUND), code: PURCHASE_STATUS.PENDING_REFUND, label: "待退款", showBadge: true },
  { name: String(PURCHASE_STATUS.PENDING_RETURN), code: PURCHASE_STATUS.PENDING_RETURN, label: "待退货", showBadge: true },
  { name: String(PURCHASE_STATUS.COMPLETED), code: PURCHASE_STATUS.COMPLETED, label: "已完成", showBadge: false },
  { name: String(PURCHASE_STATUS.VOID), code: PURCHASE_STATUS.VOID, label: "已作废", showBadge: false },
  { name: "all", code: "", label: "全部", showBadge: false },
];

export function getPurchaseStatusLabel(status) {
  if (status === "" || status === null || status === undefined) return "";
  const code = Number(status);
  return PURCHASE_STATUS_LABEL[code] || "";
}

export function getRefundStatusLabel(status) {
  if (status === "" || status === null || status === undefined) return "";
  const code = Number(status);
  if (code === REFUND_STATUS.NONE) return "";
  return REFUND_STATUS_LABEL[code] || "";
}

export function getReturnStatusLabel(status) {
  if (status === "" || status === null || status === undefined) return "";
  const code = Number(status);
  if (code === RETURN_STATUS.NONE) return "";
  return RETURN_STATUS_LABEL[code] || "";
}

export function isRefundStatusBlocked(status) {
  const code = Number(status);
  return code === REFUND_STATUS.PENDING || code === REFUND_STATUS.DONE;
}

export function isReturnStatusBlocked(status) {
  const code = Number(status);
  return code === RETURN_STATUS.PENDING || code === RETURN_STATUS.DONE;
}

export function canInitiateRefundOrReturnPurchaseStatus(status) {
  const code = Number(status);
  return code === PURCHASE_STATUS.INBOUND_DEFECT || code === PURCHASE_STATUS.COMPLETED;
}
